import React from 'react'
import moment from 'moment';
const ModuleDisplayTimeAgo = ({ value }) => {
    return (
        <>{(value) ? (moment(value).fromNow()) : null}</>
    )
}

export default ModuleDisplayTimeAgo